/**
 * eslint-disable no-unused-vars
 *
 * @format
 */

import React, { useEffect } from "react";
import { Container, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { TextDecrypt } from "../content/TextDecrypt";
import { FirstName, LastName } from "../../utils/getName";

import "./About.css";
import { useDispatch, useSelector } from "react-redux";
import { getAboutMe, getCertificate } from "../../action/notesActions";
import { toast } from "wc-toast";

const useStyles = makeStyles((theme) => ({
  main: {
    maxWidth: "100vw",
    marginTop: "3em",
    marginBottom: "auto",
  },
}));

export const About = () => {
  const classes = useStyles();
  const greetings = "Hello there!";
  const aboutme = `I'm ${FirstName} ${LastName}, a multidisciplinary 
                  designer & developer. I'm always down for something new and challenging!
                  I'm here to help you create beautifully formatted websites. 
                  My projects mostly includes web development.`;

  const dispatch = useDispatch();
  const AboutMe = useSelector((state) => state.getAboutMe);
  const { loading, error, aboutMe } = AboutMe;

  const _certificate = useSelector((state) => state.getCertificate);
  const { certificate, error: certificateError } = _certificate;

  //////////////////////////////////////////////////////
  useEffect(() => {
    // get();
    dispatch(getAboutMe());
    dispatch(getCertificate());
  }, [dispatch]);

  if (error || certificateError) {
    toast.error(error.toString(), { duration: 4000 });
  }
  console.log({ aboutMe, certificate });
  console.log(aboutMe?.AboutMe);
  //////////////////////////////////////////////////////

  return (
    <section id="about">
      <Container component="main" className={classes.main} maxWidth="md">
        <div className="about">
          <div
            className="_img"
            style={{
              backgroundImage: `url(${aboutMe?.Picture})`,
              backgroundSize: "contain",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          ></div>
          <div className="_content_wrapper">
            <Typography component="h2" variant="h5">
              <TextDecrypt text={`${greetings}`} />
            </Typography>
            <p className="aboutme">{aboutMe?.AboutMe} HIczc</p>
            <a href="#contact" className="contact-btn">
              <i className="fas fa-terminal"></i>
              <Typography component="span"> Send me a message.</Typography>
            </a>
          </div>
        </div>

        {aboutMe?.Skills && (
          <div className="Dev">
            <Typography
              // style={{ textAlign: "center" }}
              variant="h2"
              component="h2"
            >
              <TextDecrypt text={`${"My Skills"}`} />
            </Typography>
            <p>
              {aboutMe?.Skills &&
                aboutMe?.Skills.map((skill) => <span>#{skill}</span>)}
            </p>
          </div>
        )}

        {certificate?.length && (
          <div className="Dev">
            <Typography
              // style={{ textAlign: "center" }}
              variant="h2"
              component="h2"
            >
              <TextDecrypt text={`${"My Certificates"}`} />
            </Typography>
            <div className="certificate">
              <div className="certificate-container">
                {certificate?.map((certificate) =>
                  certificate?.Status ? (
                    <div
                      className="certificate-card"
                      style={{
                        background: `linear-gradient(360deg, rgb(0, 0, 0), rgba(0, 0, 0, 0) 100%) center center / cover no-repeat, url(${certificate.CertificateImage})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        width: "300px",
                        height: "300px",
                        position: "relative",
                      }}
                      key={certificate?._id}
                    >
                      <div className="certificate-text-cont">
                        <p className="certificate-header">
                          {certificate?.CertificateName}
                        </p>
                        <p className="certificate-desc">
                          {certificate?.CertificateDetails}
                        </p>
                        <div className="certificate-hash">
                          {certificate?.CertificateHash?.slice(0, 3).map(
                            (hash, index) => (
                              <span key={index} className="certificate-badge">
                                {hash}
                              </span>
                            )
                          )}
                          {certificate?.CertificateHash?.length > 3 && (
                            <span className="certificate-badge">
                              +{certificate?.CertificateHash?.length - 3} more
                            </span>
                          )}
                        </div>
                        {certificate?.CertificateLink?.active && (
                          <a
                            href={certificate?.CertificateLink?.url}
                            target="_blank"
                            className="button-style"
                          >
                            See more
                          </a>
                        )}
                      </div>
                    </div>
                  ) : null
                )}
              </div>
            </div>
          </div>
        )}
      </Container>
    </section>
  );
};
// yeabsiras.netlify.app
